
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';

export default function AdminMessages() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  return (
    <AdminLayout activeSection="messages" onSectionChange={() => {}}>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Message Center</h1>
        <p className="text-gray-600 mt-1">
          Accede a tu bandeja de mensajes del AxloWeb Message Center
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <iframe
          src="https://axloweb.com/axlowebmessagecenter/frontend/"
          className="w-full h-[90vh] border-0"
          title="AxloWeb Message Center"
        />
      </div>
    </AdminLayout>
  );
}
